module.exports = __webpack_public_path__ + "img/file-md.ac02a29d.svg";